<template>
	<b-row class="project-detail">
		<b-col md="10" offset-md="1" xl="6" offset-xl="3">
			<h1 class="h4">Update {{ projectName }}</h1>
			<p class="mb-4">Please update the following details in order to view this project.</p>
			<EditProjectForm
				:project="project"
				@submit="this.$emit('getProjectDetails')"
				:fields="missingDetails">
			</EditProjectForm>
		</b-col>
	</b-row>
</template>

<script>
// import axios from "axios";
import EditProjectForm from "@/form-components/EditProjectForm.vue";

export default {
	components: {
		EditProjectForm
	},
	props: {
		project: { type: Object, required: true }
	},
	data() {
		return {

		}
	},
	computed: {
		projectName() {
			return this.project.projectName;
		},
	},
	watch: {

	},
	mounted() {
		// this.loadData();
	},
	methods: {
		// loadData() {
		//   const url = `${this.$api_url}/v1/...`;

		//   axios
		//     .get(
		//       url,
		//       this.$auth.getReqConfig(this.$store.getters["auth/getToken"])
		//     )
		//     .then((res) => {

		//     })
		//     .catch((err) => {
		//       this.$error({
		//         msg: "Couldn't load data",
		//         obj: err,
		//       });
		//     })
		//     .finally(() => {

		//     });
		// },
	}
}
</script>

<style lang="scss" scoped>

</style>
